module.exports = __webpack_public_path__ + "02_very_short_grey.95d3b414.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_very_short_grey.png
// module id = 674t
// module chunks = 0